import { ArrowRight } from "lucide-react";
import { registerClick } from "@/lib/clicks";
import { trackAffiliateClick } from "@/lib/analytics";
import { analytics } from "@heycatch/sdk";

export const AFFILIATE_URL = "https://join.honeygain.com/GEOKAC09DC/";

export const openAffiliate = (source = "blog") => {
  analytics.trackEvent("affiliate_join_click", { location: source });
  window.open(AFFILIATE_URL, "_blank", "noopener,noreferrer");
  registerClick();
};

const AffiliateCTA = ({ label = "Claim Your $3 Bonus", testid = "affiliate-cta", dark = false }) => (
  <button
    data-testid={testid}
    onClick={() => {
      trackAffiliateClick(testid);
      openAffiliate(testid);
    }}
    className={`group inline-flex items-center gap-2.5 rounded-full px-4 py-2.5 text-sm sm:px-8 sm:py-4 sm:text-base font-display font-bold whitespace-nowrap transition-colors shadow-lg ${
      dark
        ? "bg-zinc-900 text-white hover:bg-zinc-800"
        : "bg-amber-400 text-zinc-900 hover:bg-amber-300 shadow-[0_12px_30px_-10px_rgba(245,158,11,0.6)]"
    }`}
  >
    {label}
    <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
  </button>
);

export default AffiliateCTA;
